// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Aw","widget":"e_Bw","title":"e_Cw","msrp":"e_Dw","separator":"e_Ew","textBadge":"e_Fw"};